import { useParams,useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
// eslint-disable-next-line no-unused-vars
import ReactMarkdown from "react-markdown";
import matter from "gray-matter";
import MarkdownParser from "../utils/markdownParser";

const PostPage = () => {
  const { postId } = useParams();
  const [content, setContent] = useState("");
  const [metadata, setMetadata] = useState({ title: "", date: "" });
  const navigate = useNavigate();

  useEffect(() => {
    const loadPost = async () => {
      try {
        // console.log("🔍 postId from URL:", postId);
        const context = require.context("!!raw-loader!../posts", false, /\.md$/);

        // console.log("📝 Available Markdown Files:", context.keys());
    
        const filePath = `./${postId}.md`;
    
        if (!context.keys().includes(filePath)) {
          throw new Error(`Markdown file not found: ${filePath}`);
        }
    
        const rawMarkdown = context(filePath);
        // console.log("📜 Loaded Markdown File:", rawMarkdown); // Debugging
    
        if (typeof rawMarkdown.default !== "string") {
          throw new Error("❌ Markdown file content is not a string!");
        }
    
        const { content, data } = matter(rawMarkdown.default); // ✅ Ensure this gets a string
    
        setContent(content);
        setMetadata(data);
      } catch (error) {
        console.error("❌ Error loading post:", error);
      }
    };
    

    loadPost();
  }, [postId]);

  return (
    <div className="w-full h-full overflow-auto">
      {/* Hero Banner with Title Overlay */}
      {(metadata.image || metadata.imageLight) && (
        <>
          {/* Dark theme image */}
          {metadata.image && (
            <div 
              className="relative bg-cover bg-center blog-hero-banner hero-image-dark"
              style={{
                backgroundImage: `url(/${metadata.image.replace('.png', '.webp')}), url(/${metadata.image})`,
                marginTop: 'var(--navbar-height)',
                height: '28vh',
                minHeight: '200px',
                maxHeight: '280px',
                backgroundColor: 'var(--bg-secondary)'
              }}
            >
              {/* Dark overlay for text readability */}
              <div className="absolute inset-0 bg-black bg-opacity-50"></div>
              
              {/* Title overlay */}
              <div className="absolute inset-0 flex flex-col justify-center items-center text-center px-4" style={{ textAlign: 'center' }}>
                <h1 className="text-4xl md:text-5xl font-bold text-white mb-2 drop-shadow-lg blog-hero-title" style={{ textAlign: 'center', width: '100%' }}>
                  {metadata.title}
                </h1>
                <p className="text-sm text-gray-300 drop-shadow-md opacity-80 blog-hero-date" style={{ textAlign: 'center', width: '100%' }}>
                  {metadata.date}
                </p>
              </div>
            </div>
          )}
          
          {/* Light theme image */}
          {metadata.imageLight && (
            <div 
              className="relative bg-cover bg-center blog-hero-banner hero-image-light"
              style={{
                backgroundImage: `url(/${metadata.imageLight.replace('.png', '.webp')}), url(/${metadata.imageLight})`,
                marginTop: 'var(--navbar-height)',
                height: '28vh',
                minHeight: '200px',
                maxHeight: '280px',
                backgroundColor: 'var(--bg-secondary)'
              }}
            >
              {/* Dark overlay for text readability */}
              <div className="absolute inset-0 bg-black bg-opacity-50"></div>
              
              {/* Title overlay */}
              <div className="absolute inset-0 flex flex-col justify-center items-center text-center px-4" style={{ textAlign: 'center' }}>
                <h1 className="text-4xl md:text-5xl font-bold text-white mb-2 drop-shadow-lg blog-hero-title" style={{ textAlign: 'center', width: '100%' }}>
                  {metadata.title}
                </h1>
                <p className="text-sm text-gray-300 drop-shadow-md opacity-80 blog-hero-date" style={{ textAlign: 'center', width: '100%' }}>
                  {metadata.date}
                </p>
              </div>
            </div>
          )}
        </>
      )}
      
      {/* Content - Centered wrapper */}
      <div className="w-full flex justify-center">
        <div className={`transition-all duration-300 min-h-screen w-full ${!metadata.image ? 'pt-[calc(var(--navbar-height)+1.5rem)] py-6' : 'pt-4 pb-6'}`}
          style={{
            backgroundColor: 'transparent',
            color: 'var(--text-primary)',
            maxWidth: '1200px',
            paddingLeft: '1rem',
            paddingRight: '1rem'
          }}>

        {/* Show title only if no image */}
        {!metadata.image && (
          <>
            <h1 className="text-3xl font-bold mb-2" style={{ color: 'var(--text-primary)' }}>{metadata.title}</h1>
            <p style={{ color: '#9CA3AF' }}>{metadata.date}</p>
          </>
        )}

        <div className={`prose prose-lg leading-relaxed space-y-4 ${metadata.image ? 'mt-0' : 'mt-4'}`}>
          <MarkdownParser content={content} />
        </div>
        <button 
            onClick={() => navigate("/blog")} 
            className="mt-12 px-4 py-1 text-sm rounded-lg transition"
            style={{ 
              backgroundColor: 'var(--bg-secondary)', 
              color: 'var(--text-primary)',
              border: `1px solid var(--text-secondary)`
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = 'var(--text-secondary)';
              e.target.style.opacity = '0.8';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'var(--bg-secondary)';
              e.target.style.opacity = '1';
            }}
          >
            ← Back to Blog
          </button>
        </div>
      </div>
    </div>
  );
};

export default PostPage;
